import React, { useCallback, useState, useEffect } from 'react';
import { GoChevronDown } from 'react-icons/go';
import OperationCard from './OperationCard';
import TableLoading from '../TableLoading';

const CompanyAccordion = React.memo(({ 
    company,
    index,
    isExpanded,
    loadingFilteredData,
    onToggle,
    onModuleClick,
    onCompareVersion,
    onDiscussionClick
}) => {
    const [selectedAccordionOperation, setSelectedAccordionOperation] = useState(null);

    // Quando a company for expandida, abrir o primeiro form automaticamente
    useEffect(() => {
        if (isExpanded && company.operations && company.operations.length > 0) {
            setSelectedAccordionOperation(company.operations[0].operationID);
        } else if (!isExpanded) {
            setSelectedAccordionOperation(null);
        }
    }, [isExpanded, company.operations]);

    const handleToggleOperation = useCallback((operationID) => {
        setSelectedAccordionOperation(prev => prev === operationID ? null : operationID);
    }, []);

    return (
        <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading-${index}`}>
                <button 
                    className={isExpanded ? 'collapsed' : ''} 
                    onClick={() => onToggle(index)} 
                    id={`${index}`} 
                    type="button" 
                    data-bs-toggle="collapse" 
                    aria-expanded="true" 
                    aria-controls={`collapse-${index}`}
                >
                    <GoChevronDown size={20} />
                    <span className="company-name">{company.name}</span>
                </button>
            </h2>
            <div 
                className={`accordion-collapse collapse ${isExpanded ? 'show' : ''}`} 
                aria-labelledby={`heading-${index}`} 
                data-bs-parent="#accordionExample"
            >
                <div className="accordion-body">
                    {!loadingFilteredData && company.operations && company.operations.length > 0 ? (
                        <div>
                            <div className="cards-header">
                                <div className="col-md-3">Form</div>
                                <div className="col-md-2">Last change</div>
                                <div className="col-md-2" style={{ paddingLeft: 25 }}>Sent by</div>
                                <div className="col-md-1 year-version-column">Crop Year</div>
                            </div>
                            {company.operations.map((operation) => (
                                <OperationCard
                                    key={operation.operationID}
                                    operation={operation}
                                    companyID={company.companyID}
                                    isSelected={selectedAccordionOperation === operation.operationID}
                                    onToggle={() => handleToggleOperation(operation.operationID)}
                                    onModuleClick={onModuleClick}
                                    onCompareVersion={onCompareVersion}
                                    onDiscussionClick={onDiscussionClick}
                                />
                            ))}
                        </div>
                    ) : (
                        <TableLoading />
                    )}
                </div>
            </div>
        </div>
    );
});

CompanyAccordion.displayName = 'CompanyAccordion';

export default CompanyAccordion;

